export default "__VITE_ASSET__cd0b7c25__"